module.exports = __webpack_public_path__ + "static/media/hiw-travel.ce18aca1.svg";